export enum MediaType {
    Image = "IMG",
    Video = "VID",
    Iframe = "IFM"
}
